export const getIDFromSlug = (slug: string): string => {
  let strippedId = '';

  [strippedId] = slug.split('-', 1);

  if (strippedId.length === 0) {
    throw Error(`Unable to get ID from ${slug}`);
  }

  return strippedId;
};
